import React, { useEffect, useState } from 'react';
import CartIcon from '../../icons/cart';
import { Link } from 'react-router-dom';
import AddToCart from '../AddToCart';
import BookCarousel from '../BookCarousel';


export default function BookPage() {

  document.title = `The Ice Storm by John Ashbery | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', `Published in 1987 as a standalone volume by Hanuman Books, John Ashbery's The Ice Storm is an extended prose-poem by one of the most important and influential poets of our time.`);

  return (<div className='newPageContainer'>
    <div className='productContainer'>
      <div className='productImage_container  '>
        <div className='productCarousel'>
          <BookCarousel images={['../../Series-One/Ashbery_Back.png', '../../Series-One/Ashbery_Side.png', '../../Series-One/Ashbery_Front.png']} start={1} />
        </div>
      </div>
      <div className='productInfo_container'>
        <div className='productInfo_inner'>
          <div className='productInfo'>
            <h1 className='productTitle'>The Ice Storm</h1>
            <div className='productAuthor'>John Ashbery</div>
          </div>
          <div className='productBuyControls'>
            <AddToCart context={'product'} id={'9798989378012'} />
            <div className='productPrice'>$15.99 USD</div>
          </div>
          <div className='productExcerpt'>
            …isn’t really a storm of course because unlike most storms it isn’t one till it’s over and people go outside and say will you look at that. And by then it’s of course starting to collapse. Diamond rubble, all galled glitter, heaps of this and that in corners and beside posts where the draft has left them—are you sure it’s this you were waiting for while the storm—the real one—pressed it all into the earth to emphasize a point that melts away as fast as another idea enters the chain of them in the conversation about earth and sky and woods and how you should be good to your parents and not cheat at cards.

          </div>

          <div className='productDescription'>In <em>The Ice Storm</em>'s extended prose-poem, John Ashbery looks out from atop the “diamond rubble” of winter, mounting a paean to the collapsibility of seasons in time, to the “warp” and “woof” that waves through and constructs our lives.
          </div>
          <div className='productDescription'>
            <p>The venerated American poet of the twentieth century, <strong>John Ashbery</strong> (1927-2017) remains a central influence upon the fragmentary and allusive literature of today. Ashbery drew on the trails of lived experience, his work abounding with turns of phrase (“these lacustrine cities”) that conjured whole monuments of the observed and sensed. Alongside his counterparts among the New York School and the French Surrealists, Ashbery belonged to a culture that centered the artist, as he was one, a pointillist of postmodern splintering likewise driven by a phenomenological urge to account for and embrace All. </p>
          </div>
          <div className='productMetadata'>
            <div>Series I</div>
            <div>Spring 2026</div>
            <div>ISBN 9798989378012</div>
            <div>4.125 x 2.75 inches</div>
            <div>68 Pages</div>
          </div>
        </div>
      </div>
    </div>
  </div>)

}